import { useEffect, useRef, useState } from "react";
import { ProductsViewModel } from "../../../viewmodels/setup/products/ProductsViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter, isReadOnlyUser } from "../../../shared/utility";

import SlideOver from "../../../components/slideOver/SlideOver";
import EmptyModal from "../../../components/modals/EmptyModal";

import { Link } from "react-router-dom";
import FilterDropdown from "../../../components/filterDropdown/FilterDropdown";
import ButtonSpinner from "../../../components/controls/ButtonSpinner";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

function Products(props) {
  const { addSnackbar, logout } = props;
  const {
    getProducts,
    loading,
    products,
    setSlideOver,
    slideOver,
    openImportProduct,
    setEmptyModelOpen,
    emptyModal,
    askDeleteProduct,
    getProductCategories,
    showFilters,
    setShowFilters,
    filters,
    filterComponents,
    resetFilters,
    getProductClasses,
    totalProducts,
  } = ProductsViewModel(logout, addSnackbar);

  const isReadOnly = isReadOnlyUser();

  const [currentPage, setCurrentPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    getProducts(null, currentPage, filters);
    getProductCategories();
    getProductClasses();
  }, []);

  const searchRef = useRef();

  const handleSearch = () => {
    getProducts(searchRef.current.value, 1, filters);
  };

  const handleLoadMoreData = async () => {
    setLoadingMore(true);
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    await getProducts(searchRef.current.value, nextPage, filters);
    setLoadingMore(false);
  };

  function bodyActions(rowData) {
    return (
      <div className="flex">
        <Link
          className="ml-2 rounded-md bg-main-purple px-3 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          to={"/products/" + rowData.id}
        >
          Edit
        </Link>
        {!isReadOnly && (
          <button
            onClick={() => {
              askDeleteProduct(rowData);
            }}
            className="ml-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          >
            Delete
          </button>
        )}
      </div>
    );
  }

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Products
              </h1>
              <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:gap-0 sm:rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchProduct"
                    id="searchProduct"
                    className="block w-full rounded-md border border-gray-300 pl-2 sm:rounded-l-md sm:rounded-tr-none sm:rounded-br-none sm:text-sm"
                    placeholder="Search by name or PLU"
                    ref={searchRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleSearch();
                    }}
                  />
                </div>
                <button
                  type="button"
                  className="relative inline-flex w-full items-center justify-center space-x-2 rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 sm:-ml-px sm:w-auto sm:justify-start sm:rounded-r-md"
                  onClick={() => handleSearch()}
                >
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </button>
                <FilterDropdown
                  actionCall={() =>
                    getProducts(searchRef.current.value, 1, filters)
                  }
                  filterComponents={filterComponents}
                  resetFilters={() => {
                    resetFilters();
                  }}
                  showFilters={showFilters}
                  setShowFilters={setShowFilters}
                />
                <button
                  className="ml-2 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                  onClick={openImportProduct}
                >
                  Import
                </button>

                {!isReadOnly && (
                  <Link
                    className="ml-2 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    to={"/products/new"}
                  >
                    Add product
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (
                  <div>
                    <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                      <div className="animate-pulse flex space-x-4">
                        Loading
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="overflow-hidden card-custom">
                      <DataTable
                        value={products}
                        dataKey="id"
                        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
                        cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
                        editMode="row"
                      >
                        <Column header="Name" field="name" />
                        <Column header="Name (CH)" field="name_ch" />
                        <Column header="PLU" field="plu" />
                        <Column header="Class" field="classes_name" />
                        <Column header="Category" field="categories_name" />
                        <Column header="" body={bodyActions} />
                      </DataTable>
                    </div>
                    {products.length < totalProducts ? (
                      <div className="mt-4 text-center">
                        <button
                          onClick={handleLoadMoreData}
                          disabled={loadingMore}
                          className="rounded-md bg-main-purple px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          <ButtonSpinner spin={loadingMore} text="Load More" />
                        </button>
                      </div>
                    ) : (
                      <p className="mt-4 text-center text-gray-500">
                        No more products to load
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Products)
);
